import React from 'react';
import './PopularSearches.style.css';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CaretUpOutlined, DownOutlined } from '@ant-design/icons';

const PopularSearches = ({ items = [] }) => {
  return (
    <div className="PopularSearches_layout">
      <Swiper
        direction={'vertical'}
        className="PopularSearchesSwiper"
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        loop={true}
      >
        {items?.map((item, index) => (
          <SwiperSlide key={`${index}-${item}`} virtualIndex={index}>
            <p>
              <strong>{index + 1}</strong>
              <span>
                <CaretUpOutlined />
              </span>
              {item}
            </p>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="more_btn">
        <DownOutlined />
      </div>
    </div>
  );
};

export default PopularSearches;
